const CONTESTATION_TITLE = 'Processo de contestação';

const CONTESTATION_MESSAGE =
  'Vamos ver o que aconteceu com seu pacote, por isso vamos iniciar o processo de contestação. Veja como vai funcionar:';

const CONTESTATION_MESSAGE_ITEM_ONE =
  'O entregador será avisado e vai precisar ir até o endereço de entrega.';

const CONTESTATION_MESSAGE_ITEM_TWO_BEGIN = 'Será necessário localizar ';

const CONTESTATION_MESSAGE_ITEM_TWO_END = ', que recebeu o pacote.';

const CONTESTATION_MESSAGE_ITEM_THREE =
  'O entregador confirma se o pacote está lá e quem recebeu assina a comprovação de entrega.';

const CONTESTATION_MESSAGE_ITEM_FOUR_BEGIN =
  'O entregador confirma o recebimento por ';

const CONTESTATION_MESSAGE_ITEM_FOUR_END =
  'e a gente avisa você sobre os próximos passos.';

const ATENTION_CARD_MESSAGE_TITLE =
  'Novas rotas não serão liberadas para esse entregador até que o pacote seja encontrado.';

const ATENTION_CARD_MESSAGE_CONTENT_BEGIN =
  'Por isso, é importante que você tenha certeza que o pacote não está com ';

const ATENTION_CARD_MESSAGE_CONTENT_END = 'ou na portaria do condomínio.';

const CONTESTATION_QUESTION = 'Podemos seguir com a contestação?';

const CONTESTATION_ACCEPTANCE = 'Li e concordo em iniciar o processo';

const CONTESTATION_ACCEPTANCE_BUTTON_TEXT = 'Quero iniciar a contestação';

const BUTTON_REPLY_LATER = 'Deixar para depois';

const NUMBER_ONE = '1';

const NUMBER_TWO = '2';

const NUMBER_THREE = '3';

const NUMBER_FOUR = '4';

const NUMBERED_LIST = {
  NUMBER_ONE,
  NUMBER_TWO,
  NUMBER_THREE,
  NUMBER_FOUR
};

const TEST_BUTTON_ID = 'test_accept';

const TEST_CHECK_ID = 'test_check';

export {
  CONTESTATION_TITLE,
  CONTESTATION_MESSAGE,
  CONTESTATION_MESSAGE_ITEM_ONE,
  CONTESTATION_MESSAGE_ITEM_TWO_BEGIN,
  CONTESTATION_MESSAGE_ITEM_TWO_END,
  CONTESTATION_MESSAGE_ITEM_THREE,
  CONTESTATION_MESSAGE_ITEM_FOUR_BEGIN,
  CONTESTATION_MESSAGE_ITEM_FOUR_END,
  ATENTION_CARD_MESSAGE_TITLE,
  ATENTION_CARD_MESSAGE_CONTENT_BEGIN,
  ATENTION_CARD_MESSAGE_CONTENT_END,
  CONTESTATION_QUESTION,
  CONTESTATION_ACCEPTANCE,
  CONTESTATION_ACCEPTANCE_BUTTON_TEXT,
  BUTTON_REPLY_LATER,
  NUMBERED_LIST,
  TEST_BUTTON_ID,
  TEST_CHECK_ID
};
